// Shared approved economics and disabled session/UniswapX defaults. Network
// selection must never create a second, independently editable fee policy.
export const productFlags = Object.freeze({
  sessionKeysEnabled: false,
  uniswapXEnabled: false,
} as const);

export const feePolicy = Object.freeze({
  version: '2026-09-01.v1',
  standardBps: 50,
  referredBps: 45,
  referrerShareBpsOfCollectedFee: 2_000,
} as const);
